import { commonColors } from '@linqpal/common-frontend/src/theme'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Text, View, StyleSheet } from 'react-native'
import { IconLockSmall } from '../../assets/icons'

export const DataSecuredLabel: React.FC = () => {
  const { t } = useTranslation('global')
  return (
    <View style={styles.rootView}>
      <View style={styles.childView}>
        <IconLockSmall style={{ alignSelf: 'center', marginRight: 8 }} />
        <Text style={styles.simpleText}>
          <Trans
            t={t}
            i18nKey="DataAreSecuredByBluetape"
            components={{
              styled: <Text style={styles.styledText} />,
            }}
          />
        </Text>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  rootView: {
    width: '100%',
    alignItems: 'center',
  },
  childView: {
    flexDirection: 'row',
  },
  simpleText: {
    fontWeight: '500',
    fontSize: 12,
    color: commonColors.textLight,
  },
  styledText: {
    color: '#335C75',
  },
})
